import { ConfigProvider } from "antd";
import { Outlet } from "react-router";
import "./index.css";

const Index = () => {
  return (
    <ConfigProvider
      wave={{ disabled: true }}
      theme={{
        token: {
          fontFamily: "'Quicksand', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          colorText: "#212529",
          colorLink: "#204480",
          colorPrimary: "#356AB3",
          colorBorderSecondary: "#D8DFE6"
        },
        components: {
          Button: {
            fontSize: 16,
            controlHeightLG: 44,
            paddingInlineLG: 20,
            fontWeight: 700,
            defaultHoverColor: "#212529",
            defaultActiveColor: "#212529",
          },
          // Input: {
          //   fontSize: 14,
          //   borderRadius: 3,
          //   controlHeight: 38,
          //   colorBorder: "#686e77",
          // },
          Collapse: {
            headerPadding: "16px 20px",
          },
        },
      }}
    >
      <div className="landing">
        <Outlet/>
      </div>
    </ConfigProvider>
  );
};

export default Index;
